export default "__VITE_ASSET__7ded868d__"